import { Box, Button, Flex, HStack, Text, useToast } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { RiArrowLeftLine } from "react-icons/ri";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { editarAnimal } from "store/modules/zoonose/actions/editarAnimal";
import { obterDetalheAnimal } from "store/modules/zoonose/actions/obterDetalheAnimal";
import { uploadFotosAnimal } from "store/modules/zoonose/fotos/actions/uploadFotosAnimal";
import { toNumberOrNull } from "utils/to-number-or-null";
import { FormAnimal } from "../components/FormAnimal";
import {
  formAnimalSchema,
  FormAnimalValues
} from "../components/FormAnimal/types";

export const EdicaoAnimal = () => {
  const [filesToUpload, setFilesToUpload] = useState<File[]>([]);
  const { idAnimal } = useParams<{ idAnimal: string }>();
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const methods = useForm<FormAnimalValues>({
    resolver: yupResolver(formAnimalSchema)
  });
  const handleSubmit = methods.handleSubmit;

  const { successPayload: doencas } = useTypedSelector(
    (state) => state.zoonose.obterDoencas
  );

  const { successPayload: detalheAnimal } = useTypedSelector(
    (state) => state.zoonose.obterDetalheAnimal
  );

  useEffect(() => {
    if (idAnimal) {
      dispatch(obterDetalheAnimal({ idAnimal }));
    }
  }, [idAnimal]);

  const { isRequesting } = useTypedSelector(
    (state) => state.zoonose.editarAnimal
  );
  useEffect(() => {
    if (detalheAnimal && idAnimal) {
      const doencasDefault = detalheAnimal.doencasPreexistentes.map((doenca) =>
        String(doenca.value)
      );

      methods.reset({
        ...detalheAnimal,
        especie: String(detalheAnimal.especie.value),
        sexo: String(detalheAnimal.sexo.value),
        porte: String(detalheAnimal.porte.value),
        castrado: String(detalheAnimal.castrado),
        desejaCastrar: String(detalheAnimal.desejaCastrar),
        vacinaEmDia: String(detalheAnimal.vacinaEmDia),
        doencasPreexistentes:
          doencasDefault && doencasDefault.length > 0
            ? doencasDefault
            : doencas && doencas.length > 0
            ? [String(doencas[0].value)]
            : []
      });
    } else {
      methods.reset();
    }
  }, [detalheAnimal, idAnimal]);

  const onSubmit: SubmitHandler<FormAnimalValues> = (data) => {
    const peso = data?.peso ? data.peso.toString().replace(".", ",") : "";
    if (idAnimal) {
      dispatch(
        editarAnimal({
          id: idAnimal,
          ...data,
          peso: Number(peso),
          idadeAnos: toNumberOrNull(data.idadeAnos),
          idadeMeses: toNumberOrNull(data.idadeMeses),
          castrado: data.castrado === "true" ? true : false,
          desejaCastrar: data.desejaCastrar === "true" ? true : false,
          vacinaEmDia: data.vacinaEmDia === "true" ? true : false,
          desejaVacinar: data.desejaVacinar === "true" ? true : false,
          dataUltimaVacinacao:
            data.dataUltimaVacinacao === "" ? null : data.dataUltimaVacinacao,
          dataObito: data.dataObito === "" ? null : data.dataObito,
          onSuccess: () => {
            toast({
              title: "Edição realizada com sucesso",
              status: "success",
              duration: 2000
            });
            if (filesToUpload.length > 0) {
              dispatch(
                uploadFotosAnimal({
                  idAnimal: idAnimal,
                  fotos: filesToUpload,
                  onSuccess: () => {
                    navigate("/zoonose");
                  }
                })
              );
            } else {
              navigate("/zoonose");
            }
          }
        })
      );
    }
  };

  return (
    <FormProvider {...methods}>
      <Flex justifyContent="center" alignItems="center">
        <Box
          w="full"
          maxW="container.xl"
          h="full"
          py={{ base: 8 }}
          px={{ base: 6, sm: 8, xl: 16 }}
          overflowY="visible"
          overflowX="visible"
        >
          <Link to={"/zoonose"}>
            <Button colorScheme="gray" color="gray.900" variant="link" gap={2}>
              <RiArrowLeftLine /> Voltar
            </Button>
          </Link>
          <Text as="h3">Edição</Text>

          <Box as="form" onSubmit={handleSubmit(onSubmit)}>
            <FormAnimal onFilesSelected={setFilesToUpload} />

            <HStack w="full" mt={5} justifyContent="flex-end">
              <Button
                colorScheme="green"
                variant="outline"
                isDisabled={isRequesting}
                onClick={() => navigate("/zoonose")}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                colorScheme="green"
                isLoading={isRequesting}
              >
                Editar Animal
              </Button>
            </HStack>
          </Box>
        </Box>
      </Flex>
    </FormProvider>
  );
};

export default EdicaoAnimal;
